import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {CadastrarComponent} from "./pages/cadastrar/cadastrar.component";
import {FinanceiroComponent} from "./pages/financeiro/financeiro.component";
import {AutenticacaoGuard} from "../../../core/guards/autenticacao-guard";

const routes: Routes = [
  { path: "cadastrar/:guid", component: CadastrarComponent },
  { path: "financeiro", component: FinanceiroComponent, canActivate: [AutenticacaoGuard] },
  { path: "meu-plano", component: CadastrarComponent, canActivate: [AutenticacaoGuard] },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmpresaRoutingModule { }
